<template>
  <v-chip :color="getTypeColor(role.name)" text-color="white" label>
    {{ role.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'UserRole',
  props: {
    role: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTypeColor(name) {
      let color = 'default'

      switch (name) {
        case 'ADMIN':
          color = '#e91e63'
          break

        case 'CUSTOMER':
          color = '#4caf50'
          break

        case 'CUSTOMER_UNCONFIRMED':
          color = '#ff9800'
          break

        default:
          color = 'default'
      }

      return color
    },
  },
}
</script>
